import { FormQuestionType } from '@/store/modules/enums';
import { FormQuestion, FormQuestionAnswer, FormQuestionOptions } from '@/store/modules/types';
import moment from 'moment';

export function prepareFormQuestions(questions: any[]) {
    return questions.map((q: any) => {
        // SET OPTIONS
        let options: FormQuestionOptions | null = null;
        if (q.options) {
            options = JSON.parse(q.options);
            if (options && options.list) {
                options.list = options.list.map(opt => {
                    opt.checked = false;
                    return opt;
                });
            }
        }
        // SET ANSWER
        let { defaultAnswer } = q;
        if (defaultAnswer) {
            if (defaultAnswer === '@DATE_TIME' && q.type === FormQuestionType.DATE_TIME) {
                defaultAnswer = JSON.stringify({
                    date: moment().toDate(),
                    time: moment().format("HH:mm:ss")
                });
            } else {
                defaultAnswer = defaultAnswer.replace("@DATE_TIME", moment().format("MMM DD, YYYY hh:mm A"));
                defaultAnswer = defaultAnswer.replace("@DATE", moment().format("MMM DD, YYYY"));
                defaultAnswer = defaultAnswer.replace("@TIME", moment().format("hh:mm A"));
            }
        }
        const answer: FormQuestionAnswer = {
            value: q.answerValue || defaultAnswer,
            created: q.answerCreated,
            createdBy: q.answerCreatedBy,
            updated: q.answerUpdated,
            updatedBy: q.answerUpdatedBy,
            jumpToKey: null,
            updateGap:null,
        };
        // SET COMPONENT
        let component = "";
        switch (q.type) {
            case FormQuestionType.TEXT:
                component = "TextAnswer";
                break;
            case FormQuestionType.EDITOR:
                component = "EditorAnswer";
                break;
            case FormQuestionType.NUMBER:
                component = "TextAnswer";
                break;
            case FormQuestionType.NUMBER_RANGE:
                component = "TextAnswer";
                break;
            case FormQuestionType.DATE:
                component = "DateAnswer";
                break;
            case FormQuestionType.TIME:
                component = "TimeAnswer";
                break;
            case FormQuestionType.DATE_TIME:
                component = "DateTimeAnswer";
                break;
            case FormQuestionType.DATE_RANGE:
                component = "TextAnswer";
                break;
            case FormQuestionType.BIRTHDATE:
                component = "TextAnswer";
                break;
            case FormQuestionType.SINGLE_CHOICE:
                component = "SingleChoiceAnswer";
                break;
            case FormQuestionType.MULTIPLE_CHOICE:
                component = "MultipleChoiceAnswer";
                break;
        }
        // SET QUESTION
        const { id, key, position, section, title, text, isOptional,isExpired } = q;
        const question: FormQuestion = {
            id,
            key,
            position,
            section,
            title,
            text,
            component,
            options,
            isOptional,
            isExpired,
            answer
        }
        //
        return question;
    });
}